module.exports = __webpack_public_path__ + "media/images/banner-img-6e6416d3b9412d54fc372b1fb33aebc9.png";